module.exports = __webpack_public_path__ + "static/media/JustAct Icons for Case Manager Site_V4-02.6687a7f4.svg";